  (() => {
    // Per-instance config rides on this script tag; see the note below.
    const me = document.currentScript;
    if (!me || !me.dataset.sectionId) return;
    const initKey = 'dynamicSelectorInitialized_' + me.dataset.sectionId;
    const sectionId = 'shopify-section-' + me.dataset.sectionId;
    const initialIndex = me.dataset.initialIndex;

    const getScrollPadding = (track) => {
      const styles = getComputedStyle(track);
      return parseFloat(styles.scrollPaddingInlineStart || styles.scrollPaddingLeft) || 0;
    };

    const setActiveSwatch = (swatches, index) => {
      const activeIndex = String(index);
      swatches.forEach((swatch) => {
        const isActive = swatch.dataset.colorIndex === activeIndex;
        swatch.classList.toggle('is-active', isActive);
        swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const getClosestSegment = (track, segments) => {
      if (!track || !segments.length) return null;

      const targetLeft = track.scrollLeft + getScrollPadding(track);
      let closestSegment = segments[0];
      let closestDistance = Math.abs(segments[0].offsetLeft - targetLeft);

      segments.slice(1).forEach((segment) => {
        const distance = Math.abs(segment.offsetLeft - targetLeft);
        if (distance < closestDistance) {
          closestSegment = segment;
          closestDistance = distance;
        }
      });

      return closestSegment;
    };

    const scrollToSegment = (track, segment, behavior = 'smooth') => {
      if (!track || !segment) return;

      const left = Math.max(0, segment.offsetLeft - getScrollPadding(track));

      if (behavior === 'auto') {
        track.scrollLeft = left;
        return;
      }

      track.scrollTo({ left, behavior });
    };

    const updateNav = (track, nav, leftBtn, rightBtn) => {
      if (!track || !nav || !leftBtn || !rightBtn) return;

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const isDesktop = window.innerWidth > 768;
      const hasOverflow = isDesktop && maxScroll > 1;

      nav.classList.toggle('is-active', hasOverflow);
      leftBtn.disabled = !hasOverflow || track.scrollLeft <= 2;
      rightBtn.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 2;
    };

    function bindSection(sectionEl) {
      if (!sectionEl || sectionEl.dataset.dsInit === 'true') return;

      const track = sectionEl.querySelector('.ds__track');
      const segments = Array.from(sectionEl.querySelectorAll('.ds__segment'));
      if (!track || !segments.length) return;

      sectionEl.dataset.dsInit = 'true';

      const swatches = Array.from(sectionEl.querySelectorAll('.ds__swatch'));
      const nav = sectionEl.querySelector('.ds__nav');
      const leftBtn = nav ? nav.querySelector('.ds__arrow--left') : null;
      const rightBtn = nav ? nav.querySelector('.ds__arrow--right') : null;
      let scrollFrame = null;

      const syncState = () => {
        const closestSegment = getClosestSegment(track, segments);
        if (closestSegment) {
          setActiveSwatch(swatches, closestSegment.dataset.colorIndex);
        }
        updateNav(track, nav, leftBtn, rightBtn);
      };

      swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          const segment = segments.find((item) => item.dataset.colorIndex === swatch.dataset.colorIndex);
          if (!segment) return;

          setActiveSwatch(swatches, swatch.dataset.colorIndex);
          scrollToSegment(track, segment);
        });
      });

      const scrollBySegment = (direction) => {
        const currentSegment = getClosestSegment(track, segments);
        if (!currentSegment) return;

        const currentIndex = segments.indexOf(currentSegment);
        const nextIndex = Math.max(0, Math.min(segments.length - 1, currentIndex + direction));

        if (nextIndex !== currentIndex) {
          scrollToSegment(track, segments[nextIndex]);
        }
      };

      if (leftBtn) {
        leftBtn.addEventListener('click', () => scrollBySegment(-1));
      }

      if (rightBtn) {
        rightBtn.addEventListener('click', () => scrollBySegment(1));
      }

      track.addEventListener('scroll', () => {
        if (scrollFrame) return;

        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = null;
          syncState();
        });
      }, { passive: true });

      window.addEventListener('resize', syncState);

      const initialSegment = segments.find((segment) => segment.dataset.colorIndex === initialIndex) || segments[0];
      if (initialSegment) {
        scrollToSegment(track, initialSegment, 'auto');
        setActiveSwatch(swatches, initialSegment.dataset.colorIndex);
      }

      requestAnimationFrame(syncState);
    }

    function init() {
      var el = document.getElementById(sectionId);
      if (!el) return;
      // Defer per-section wiring (bindSection forces synchronous layout) until
      // the section nears the viewport. The homepage stacks 8 of these; only the
      // near-fold one binds at load (400px margin keeps the first one eager),
      // the other 7 wire on scroll-approach. bindSection is idempotent (dsInit).
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            obs.disconnect();
            bindSection(el);
          }
        }, { rootMargin: '400px 0px' });
        io.observe(el);
      } else {
        bindSection(el);
      }
    }

    if (!window[initKey]) {
      window[initKey] = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

      document.addEventListener('shopify:section:load', (event) => {
        if (event.detail.sectionId === me.dataset.sectionId) {
          requestAnimationFrame(init);
        }
      });
    } else {
      init();
    }
  })();
